import type { AllRouteEndpoints } from "../routeTypes";
export const postDecisioningStudioAgentsAppGroupIdDsaIdCampaignsCacheKeys: AllRouteEndpoints[] = [
  "/engagement/get_changelogs",
];
